import { IndustryComparison } from '../../../types/industry/Industry'

export const SET_INDUSTRY_COMPARISON_DATA = 'SET_INDUSTRY_COMPARISON_DATA'

export interface SetIndustryComparisonData {
  type: typeof SET_INDUSTRY_COMPARISON_DATA
  payload: IndustryComparison[]
}
